import { t } from "i18next";
import TabsMobile from "../__template/TabsMobileComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, Fragment, useEffect, useState } from "react";
import users from "../../assets/images/icon_profile/user.svg";
import Config from "../../config/Config";
import { Range } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRangePicker from "../common/DateRangePicker";
import Voice from "../../assets/images/icon_recitation/voice.svg";
import Common from "../../assets/images/icon_recitation/common.svg";
import Setoran from "../../assets/images/icon_recitation/dashboard_setoran.svg";
import TidakSetoran from "../../assets/images/icon_recitation/dashboard_tidak_setoran.svg";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import {
  ArrowPathIcon,
  ChevronUpIcon,
  CloudArrowUpIcon,
} from "@heroicons/react/20/solid";
import {
  getDataRecitation,
  getSubTypeRecitation,
  getSummaryRecitation,
  getTypeRecitation,
} from "../../core/service/api_recitation";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { toast } from "react-toastify";

type DashboardData = {
  setoran: number;
  tidak_setoran: number;
};

const RecitationSubmissionReportMobile = () => {
  const env = Config.BaseUrlDev;
  const location: any = useLocation();
  const [child, setChild] = useState<any>({});
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenProcess, setIsProcess] = useState<boolean>(false);
  const [setoranList, setSetoranList] = useState([]);
  const [typeRecitationList, setTypeRecitationList] = useState([]);
  const [recitationType, setRecitationType] = useState<string>("");
  const [filterRecitationMethod, setFilterRecitationMethod] =
    useState<string>("");
  const [dashboardData, setDashboardData] = useState<DashboardData>(
    {} as DashboardData
  );
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });

  const company = JSON.parse(localStorage.getItem("company")!);
  const [query, setQuery] = useState([
    `caller_id=${location.state.data.callerId}`,
    `caller_name=${location.state.data.name}`,
    `company_id=${company.id}`,
  ]);

  const navigate = useNavigate();

  const handleDateChange = (range: any) => {
    setSelectedRange(range);
  };

  useEffect(() => {
    getData();
  }, [selectedRange]);

  useEffect(() => {
    getData();
  }, [recitationType]);

  useEffect(() => {
    getData();
  }, [filterRecitationMethod]);

  // useEffect(() => {
  //     getData()
  // },[query])

  // useEffect(() => {
  //     console.log(filterRecitationMethod === 'audio')
  //     setQuery((prev) => {
  //         const withoutKey = prev.filter((item) => !item.startsWith("is_audio_hafalan="));
  //         return [...withoutKey, `is_audio_hafalan=${filterRecitationMethod === 'audio'}`];
  //     });
  // }, [filterRecitationMethod])

  // useEffect(() => {
  //     setQuery((prev) => {
  //         const withoutKey = prev.filter((item) => !item.startsWith("tipe_setoran_id="));
  //         return [...withoutKey, `tipe_setoran_id=${recitationType}`];
  //     });
  //     getData()
  // }, [recitationType])

  const handleChangeRecitationMethod = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setFilterRecitationMethod(event.target.value);
  };
  const handleChangeRecitationType = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    console.log(event.target.value);

    setRecitationType(event.target.value);
  };

  const loadMoreData = () => {
    setPage((prevPage) => prevPage + 1);
    dispatch(setLoading(true));
    let queryData = [
      `caller_id=${location.state.data.callerId}`,
      `caller_name=${location.state.data.name}`,
      `company_id=${company.id}`,
      `page=${page + 1}`,
      "size=10",
      "status=Pub",
    ];
    if (selectedRange.startDate)
      queryData.push(`startDate=${selectedRange.startDate}`);
    if (selectedRange.endDate)
      queryData.push(`endDate=${selectedRange.endDate}`);
    if (recitationType) queryData.push(`tipe_setoran_id=${recitationType}`);
    if (filterRecitationMethod)
      queryData.push(`is_audio_hafalan=${filterRecitationMethod}`);
    getDataRecitation(queryData)
      .then(({ data }) => {
        console.log(data);
        setTotalPage(data.totalPages);
        setSetoranList(setoranList.concat(data.content));
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
    console.log("total page", totalPage);
  };
  const getData = () => {
    dispatch(setLoading(true));
    let queryData = [
      `caller_id=${location.state.data.callerId}`,
      `caller_name=${location.state.data.name}`,
      `company_id=${company.id}`,
      `page=${page}`,
      "size=10",
      "status=Pub",
    ];
    if (selectedRange.startDate)
      queryData.push(`startDate=${selectedRange.startDate}`);
    if (selectedRange.endDate)
      queryData.push(`endDate=${selectedRange.endDate}`);
    if (recitationType) queryData.push(`tipe_setoran_id=${recitationType}`);
    if (filterRecitationMethod)
      queryData.push(`is_audio_hafalan=${filterRecitationMethod}`);
    getDataRecitation(queryData)
      .then(({ data }) => {
        console.log(data);
        setSetoranList(data.content);
        setTotalPage(data.totalPages);
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const getResume = () => {
    dispatch(setLoading(true));
    let queryData = [
      `caller_id=${location.state.data.callerId}`,
      `company_id=${company.id}`,
    ];
    if (selectedRange.startDate)
      queryData.push(`startDate=${selectedRange.startDate}`);
    if (selectedRange.endDate)
      queryData.push(`endDate=${selectedRange.endDate}`);
    if (recitationType) queryData.push(`tipe_setoran_id=${recitationType}`);
    if (filterRecitationMethod)
      queryData.push(`is_audio_hafalan=${filterRecitationMethod}`);
    getSummaryRecitation(queryData)
      .then(({ data }) => {
        console.log(data);
        setDashboardData(data);
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const getTypeRecitationData = () => {
    getTypeRecitation(company.id).then(({ data }) => {
      console.log(data);
      setTypeRecitationList(data);
    });
  };
  useEffect(() => {
    console.log(location.state.data);
    setChild(location.state.data);
    getData();
    getTypeRecitationData();
    getResume();
  }, []);

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_a/image/get/" + photo + "/pas";
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const openProcess = () => {
    setIsProcess(true);
    setTimeout(() => {
      closeProcess();
    }, 3000);
  };

  const closeProcess = () => {
    setIsProcess(false);
  };

  const handleUploadFile = () => {
    openProcess();
  };
  return (
    <>
      <div className="relative min-h-screen h-full bg-psp-primary pb-10 font-montserrat">
        {/* <div className="bg-psp-primary px-8 pt-8 pb-3  sticky top-0">
                    <TabsMobile
                        name={`${t("RECITATION.recitationHistoryReport")}`}
                        backUrl={"home"}
                    ></TabsMobile>
                </div> */}
        <div className="flex flex-col p-2">
          <div className="bg-white p-2 rounded-3xl flex-row flex gap-3 items-center">
            <img
              src={getProfileImage(child.photoUrl)}
              alt="profile"
              className="w-14 h-14 rounded-full flex-0 object-cover"
            />
            <div className="flex flex-col grow">
              <h1 className="font-montserrat text-xs  font-medium text-psp-nav">
                {t("RECITATION.welcome")}
              </h1>
              <h1 className="font-montserrat text-sm font-bold">
                {child.name?.split(" ").length > 3
                  ? child.name?.split(" ").slice(0, 2).join(" ")
                  : child.name}
              </h1>
            </div>
          </div>
          <section className="mt-4 p-2">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                    <span className="text-lg font-bold text-dark">Filter</span>
                    <ChevronUpIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-8 w-8 text-purple-500`}
                    />
                  </Disclosure.Button>
                  <Transition
                    enter="transition duration-200 ease-out"
                    enterFrom="transform opacity-0 -translate-y-2"
                    enterTo="transform opacity-100 translate-y-0"
                    leave="transition duration-150 ease-in"
                    leaveFrom="transform opacity-100 translate-y-0"
                    leaveTo="transform opacity-0 -translate-y-2"
                  >
                    <Disclosure.Panel className="text-sm text-gray-500">
                      <label
                        className="form-label text-gray-500"
                        htmlFor="recitation-type"
                      >
                        {t("RECITATION.dateRange")}
                      </label>
                      <DateRangePicker onChange={handleDateChange} />
                      <div className="mt-3">
                        <label
                          className="form-label text-gray-500"
                          htmlFor="recitation-method"
                        >
                          {t("RECITATION.recitationMethod")}
                        </label>
                        <select
                          className="form-select form-select-md"
                          aria-label="Tipe setoran"
                          id="recitation-method"
                          value={filterRecitationMethod}
                          onChange={(e) => handleChangeRecitationMethod(e)}
                        >
                          <option value="">
                            {t("RECITATION.recitationMethodBoth")}
                          </option>
                          <option value="true">
                            {t("RECITATION.recitationMethodAudio")}
                          </option>
                          <option value="false">
                            {t("RECITATION.recitationMethodNonAudio")}
                          </option>
                        </select>
                      </div>
                      <div className="mt-3">
                        <label
                          className="form-label text-gray-500"
                          htmlFor="recitation-type"
                        >
                          {t("RECITATION.recitationType")}
                        </label>
                        <select
                          className="form-select form-select-md"
                          aria-label="Jenis setoran"
                          id="recitation-type"
                          value={recitationType}
                          onChange={(e) => handleChangeRecitationType(e)}
                        >
                          <option value="">Show All</option>
                          {typeRecitationList.map(
                            (type: any, index: number) => {
                              return (
                                <option key={index} value={type._id}>
                                  {type.hafalanType}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          </section>
          <section className="mt-4">
            <div className="p-2">
              <p className="text-lg font-bold">Dashboard</p>
              <div className="grid grid-cols-2 gap-2">
                <div className="flex flex-row bg-white h-20 rounded-xl pl-2">
                  <img src={Setoran} alt="" className="w-16" />
                  <div className="p-2 flex flex-col">
                    <p className="font-semibold">{dashboardData.setoran}</p>
                    <p className="text-xs -mt-2">Setoran</p>
                  </div>
                </div>
                <div className="flex flex-row bg-white h-20 rounded-xl pl-2">
                  <img src={TidakSetoran} alt="" className="w-16" />
                  <div className="p-2 flex flex-col">
                    <p className="font-semibold">
                      {dashboardData.tidak_setoran}
                    </p>
                    <div className="w-full">
                      <p className="text-xs -mt-2">Tidak Setoran</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="mt-4">
            <div className="p-2">
              <p className="text-lg font-bold">
                {t("RECITATION.recitationHistory")}
              </p>
              <div className="flex flex-col gap-2 justify-items-center">
                {setoranList.length ? (
                  setoranList.map((data: any, index) => (
                    <div
                      className="w-full rounded-lg bg-white h-18 flex flex-row p-2 gap-2"
                      key={index}
                      onClick={() =>
                        navigate("/setoran-hafalan/detail", {
                          state: {
                            data,
                          },
                        })
                      }
                    >
                      <img src={data.isAudioHafalan ? Voice : Common} alt="" />
                      <div className="flex flex-col align-middle w-full">
                        <p className="font-semibold text-sm">
                          Hafalan {data.isAudioHafalan ? "Audio" : "Non Audio"}
                        </p>
                        <table className="w-full text-xs -mt-3">
                          <tbody>
                            <tr>
                              <td>Nama</td>
                              <td>:</td>
                              <td className="text-right">{data.surat}</td>
                            </tr>
                            <tr>
                              <td>Tanggal setoran</td>
                              <td>:</td>
                              <td className="text-right">
                                {moment(data.tanggalSetoran)
                                  .locale("id")
                                  .format("LL")}
                              </td>
                            </tr>
                            <tr>
                              <td>Nilai</td>
                              <td>:</td>
                              <td className="text-right">
                                {data.scores.finalScore} (
                                {data.scores.predicateScore
                                  ? data.scores.predicateScore
                                  : "-"}
                                )
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>Tidak ada data</p>
                )}
                {page + 1 < totalPage ? (
                  <div className="flex w-full">
                    <button
                      onClick={loadMoreData}
                      className={`w-full bg-psp-btn-primary px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${"text-white"}`}
                    >
                      {t("OTHER.showMore")}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default RecitationSubmissionReportMobile;
